// SA postcode → suburb lookup. Covers Adelaide metro + surrounds.
// Not exhaustive; just enough that a user entering a postcode in the
// Criteria panel gets the suburb name resolved automatically.
// If your suburb isn't here, type the name manually.

export const POSTCODE_TO_SUBURB = Object.freeze({
  // Inner / CBD
  '5000': 'Adelaide',
  '5005': 'Adelaide University',
  '5006': 'North Adelaide',
  '5007': 'Hindmarsh',
  '5008': 'Croydon',
  '5009': 'Allenby Gardens',

  // Inner south
  '5031': 'Mile End',
  '5032': 'Lockleys',
  '5033': 'Marleston',
  '5034': 'Millswood',
  '5035': 'Keswick',
  '5037': 'Plympton',
  '5038': 'Plympton Park',
  '5039': 'Edwardstown',
  '5040': 'Novar Gardens',
  '5041': 'Colonel Light Gardens',
  '5042': 'Bedford Park',
  '5043': 'Park Holme',
  '5044': 'Glenelg North',
  '5045': 'Glenelg',
  '5046': 'Warradale',
  '5047': 'Darlington',
  '5048': 'Hove',
  '5049': 'Brighton',
  '5050': 'Bedford Park',

  // Southern corridor (our default hunting ground)
  '5158': "O'Halloran Hill",
  '5159': 'Aberfoyle Park',
  '5160': 'Christie Downs',
  '5161': 'Reynella',
  '5162': 'Morphett Vale',
  '5163': 'Hackham',
  '5164': 'Christie Downs',
  '5165': 'Christies Beach',
  '5166': 'Lonsdale',
  '5167': 'Port Noarlunga',
  '5168': 'Noarlunga Centre',
  '5169': 'Seaford',
  '5170': 'Seaford Rise',
  '5171': 'Aldinga Beach',
  '5172': 'Willunga',

  // Eastern
  '5065': 'Toorak Gardens',
  '5066': 'Rose Park',
  '5067': 'Norwood',
  '5068': 'Kensington Gardens',
  '5069': 'St Morris',
  '5070': 'Firle',
  '5072': 'Magill',

  // North-east
  '5082': 'Prospect',
  '5083': 'Nailsworth',
  '5084': 'Blair Athol',
  '5085': 'Kilburn',
  '5086': 'Hampstead Gardens',
  '5087': 'Hillcrest',
  '5088': 'Holden Hill',
  '5089': 'Highbury',
  '5090': 'Hope Valley',

  // Northern
  '5091': 'Tea Tree Gully',
  '5092': 'Modbury',
  '5093': 'Valley View',
  '5094': 'Pooraka',
  '5095': 'Mawson Lakes',
  '5096': 'Para Hills',
  '5097': 'Wynn Vale',
  '5098': 'Ingle Farm',

  // Salisbury / Elizabeth
  '5108': 'Salisbury Park',
  '5109': 'Para Hills West',
  '5112': 'Elizabeth',
  '5113': 'Elizabeth Vale',
  '5114': 'Craigmore',
  '5115': 'Munno Para',
  '5116': 'Smithfield',
  '5117': 'Andrews Farm',
  '5118': 'Gawler',

  // Hills
  '5152': 'Stirling',
  '5153': 'Aldgate',
  '5154': 'Heathfield',
  '5155': 'Crafers West',
  '5156': 'Belair',
  '5157': 'Blackwood',
});

export function suburbFromPostcode(postcode) {
  if (!postcode) return null;
  return POSTCODE_TO_SUBURB[String(postcode).trim()] ?? null;
}
